// 全局getters
const getters = {
	userInfo: state => state.user.userInfo,
	// 用户类型, 2: 企业账号，4: 个人账号
	userType: state => state.user.userType,
	roles: state => state.user.roles,
	token: state => state.user.token,
	sessionId: state => state.user.sessionId,
	userId: state => state.user.userId,
	realName: state => state.user.realName,
	phone: state => state.user.phone,
	// 是否绑定企业
	isHasCompany: state => state.enterprise.isHasCompany,
	companyId: state => state.enterprise.companyId,
	// 是否是企业管理员
	isCompanyAdmin: state => state.enterprise.isCompanyAdmin,
	vipLevel: state => state.vip.vipLevel,
	// 是否是普通会员
	isNormalVip: state => state.vip.vipLevel === 'PTHY',
	// 是否是高级会员
	isVip: state => state.vip.vipLevel === 'VIP',
	// 是否是超级会员
	isSVip: state => state.vip.vipLevel === 'SVIP',
	// 当前用户已开通的店铺信息，由 myShop 接口查询并缓存。
	merchantShopInfo: state => state.merchantShop.shopInfo,
	// 当前用户最近一次店铺申请信息，包含申请内容、审核状态及审核意见。
	merchantLatestApply: state => state.merchantShop.latestApply,
	// 店铺上下文是否已完成首次加载，用于判断能否直接复用缓存数据。
	merchantShopLoaded: state => state.merchantShop.loaded,
	// 是否已经具备服务商业务权限：已有店铺或最新开店申请审核通过。
	isMerchantShopApproved: (state, getters) => getters['merchantShop/isApproved'],
	// 当前用户是否提交过店铺申请，不区分审核中、通过或未通过状态。
	hasMerchantShopApplied: (state, getters) => getters['merchantShop/hasApplied']
}

export default getters
